import React from "react"
import styled from "styled-components"
import Loading from "@irati/ui/src/Loading"
import {TABLET, DESKTOP} from "@irati/ui/src/global/media"
import {CustomStatus} from "./CustomStatus"

type Props = {
  err: Error | null | undefined
}

export const DealStatus = ({err}: Props) => {
  const errPromise = err ? Promise.reject(err) : null
  if(!errPromise || !err?.message ) {
    return null
  }

  const isStockError = err.message.includes("noStock")
  const stockErr = isStockError ? errPromise : null
  const otherErr = stockErr ? null : errPromise

  return (
    <Style>
      <Loading load={otherErr} useLoader={false} />
      <Loading load={stockErr} useLoader={false} Error={CustomStatus} />
    </Style>
  )
}

const Style = styled.div`
  @media (min-width: ${TABLET}px and max-width: ${DESKTOP}px) {
    margin-top: ${({theme}) => theme.spacing.one}
  }
`
